import { script } from 'playcanvas';

 
export const ASSET_PREFIX = "";
export const SCRIPT_PREFIX = "";
export const SCENE_PATH = "2548339.json";

export const CONTEXT_OPTIONS = {
    'antialias': true,
    'alpha': false,
    'preserveDrawingBuffer': false,
    'deviceTypes': [`webgl2`, `webgl1`],
    'powerPreference': "low-power"
};

export const SCRIPTS = [ 298596253, 298596219, 298596154, 298596220, 298596356, 298596221, 298596295, 298596130, 298596345, 298596320, 298596318, 298596192, 298596317, 298596321, 298596324, 298596162, 298596339, 298596337, 298596344, 298596229, 298596343, 298596338, 298596206, 298596166, 298596379, 298596346, 298596198, 298596186, 298596434, 298596388, 298596378, 298596189, 298596390, 298596158, 298596365, 298596358, 298596361, 298596357, 298596348, 298596363, 298596373, 298596392, 298596389, 298596168, 298596457, 298596153, 298596160, 298596431, 298596454, 298596225, 298596227, 298596450, 298596435, 298596163, 298596336, 298596144, 298596452, 298596470, 300171446, 300172121, 300310934, 301069979, 301645996, 301645999, 301646000, 301823903, 301823904, 302260312, 302268955 ];
export const CONFIG_FILENAME = "config.json";
export const INPUT_SETTINGS = {
    useKeyboard: true,
    useMouse: true,
    useGamepads: false,
    useTouch: true
};
export const PRELOAD_MODULES = [
    {'moduleName' : 'BASIS', 'glueUrl' : 'files/assets/298596199/1/basis.wasm.js', 'wasmUrl' : 'files/assets/298596202/1/basis.wasm.wasm', 'fallbackUrl' : 'files/assets/298596200/1/basis.js', 'preload' : false},
    {'moduleName' : 'Ammo', 'glueUrl' : 'files/assets/298596292/1/ammo.wasm.js', 'wasmUrl' : 'files/assets/298596294/1/ammo.wasm.wasm', 'fallbackUrl' : '', 'preload' : true},
    {'moduleName' : 'DracoDecoderModule', 'glueUrl' : 'files/assets/298596303/1/draco.wasm.js', 'wasmUrl' : 'files/assets/298596304/1/draco.wasm.wasm', 'fallbackUrl' : 'files/assets/298596306/1/draco.js', 'preload' : true},
];
    
script.legacy = false;
